<ng-template #customEventTemplate let-day="day" let-openDay="openDay" let-locale="locale" let-tooltipPlacement="tooltipPlacement" let-highlightDay="highlightDay" let-unhighlightDay="unhighlightDay" let-eventClicked="eventClicked" let-tooltipTemplate="tooltipTemplate" let-tooltipAppendToBody="tooltipAppendToBody" let-tooltipDelay="tooltipDelay" let-trackByEventId="trackByEventId" let-validateDrag="validateDrag">
  <div style="flex: 1 0 auto;display:flex;flex-direction: column;" [ngClass]="{ 'non-working-day': !isWorkingDay(day) }">
    <div class="cal-cell-top" [attr.aria-label]="
      { day: day, locale: locale } | calendarA11y : 'monthCell'
    ">
      <span aria-hidden="true">
        <span class="cal-day-badge cal-day-weeknumber" *ngIf="day.date | dfnsIsMonday">Uge {{
        day.date | dfnsGetISOWeek
      }}</span>
        <span class="cal-day-number">{{
        day.date | calendarDate : "monthViewDayNumber" : locale
      }}</span>
      </span>
    </div>
    <div class="cal-events" *ngIf="day.events.length > 0">
      @for(event of day.events; track event.id) {
      <div class="cal-event" [ngClass]="event.cssClass" (mouseenter)="highlightDay.emit({ event: event })" (mouseleave)="unhighlightDay.emit({ event: event })" [mwlCalendarTooltip]="
        event.title | calendarEventTitle : 'monthTooltip' : event
      " [tooltipPlacement]="tooltipPlacement" [tooltipEvent]="event" [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody" [tooltipDelay]="tooltipDelay" mwlDraggable [class.cal-draggable]="event.draggable" dragActiveClass="cal-drag-active" [dropData]="{ event: event, draggedFrom: day }" [dragAxis]="{ x: event.draggable, y: event.draggable }" [validateDrag]="validateDrag" [touchStartLongPress]="{ delay: 300, delta: 30 }" (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })">
        <div style="display:flex;flex-direction: row;align-items: center;;">
          @if (event.meta.type == CalendarItemType.DenyDate) {
          <mat-icon class="event-type-icon">lock</mat-icon>
          } @else if (event.meta.type == CalendarItemType.Comment) {
          <mat-icon class="event-type-icon">comment</mat-icon>
          } @else if (event.meta.type == CalendarItemType.HqNonWorkingDayExplicit || event.meta.type == CalendarItemType.HqNonWorkingDayImplicit) {
          <mat-icon class="event-type-icon">domain_disabled</mat-icon>
          }

          <span style="flex: 1 0 auto;">{{ event.title }}</span>
          <span style="flex: 0 0 auto;">
            @if (event.meta.type != CalendarItemType.HqNonWorkingDayImplicit) {
            <mat-icon (click)="handleBlackoutDateDeleteClicked(event.meta)">delete</mat-icon>
            }
          </span>
        </div>
      </div>
      }
    </div>
  </div>
</ng-template>

<div>
  <app-main-heading headingText="Administrations kalender"></app-main-heading>
  <div style="display:flex;flex-direction: row;align-items: center; justify-content: center;gap:10px;">
    <button mat-button mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChanged($event)">Forrige</button>
    <h3 style="margin:0;width: 160px;text-align: center;">{{ viewDate | calendarDate:(view + 'ViewTitle'):'da' }}</h3>
    <button mat-button mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChanged($event)">Næste</button>
  </div>


  <mwl-calendar-month-view [viewDate]="viewDate" [events]="calendarEvents" locale="da" [cellTemplate]="customEventTemplate" [weekStartsOn]="1" (dayClicked)="handleDayClicked($event.day)"></mwl-calendar-month-view>
</div>
